module.exports = __webpack_public_path__ + "img/whyluckperms-2.79312c73.png";